export const TWG_CLI_DOCS_URL = 'https://developer.atlassian.com/cloud/twg-cli/';
export const TWG_CLI_INSTALLATION_URL =
	'https://developer.atlassian.com/cloud/twg-cli/getting-started/installation/';
export const TWG_MCP_CONNECT_URL =
	'https://support.atlassian.com/atlassian-rovo-mcp-server/docs/getting-started-with-the-atlassian-remote-mcp-server/';
export const ROVO_CONNECTORS_URL = 'https://www.atlassian.com/software/rovo/connectors';

/**
 * Destinations for the CLI page's "Get started" section. These resolve against
 * the `platform/teamwork-graph` documentation tree rather than the shorter
 * `cloud/twg-cli` aliases used by the constants above.
 */
const TWG_CLI_PLATFORM_DOCS_URL = 'https://developer.atlassian.com/platform/teamwork-graph/twg-cli';

export const TWG_CLI_INSTALL_GUIDE_URL: string = `${TWG_CLI_PLATFORM_DOCS_URL}/getting-started/installation/`;
export const TWG_CLI_AUTHENTICATION_URL: string = `${TWG_CLI_PLATFORM_DOCS_URL}/getting-started/configure-oauth/`;
export const TWG_CLI_AGENT_SKILLS_URL: string = `${TWG_CLI_PLATFORM_DOCS_URL}/agents/skills/`;
export const TWG_CLI_AGENT_EXAMPLES_URL: string = `${TWG_CLI_PLATFORM_DOCS_URL}/agents/examples/`;
export const TWG_CLI_CHANGELOG_URL: string = `${TWG_CLI_PLATFORM_DOCS_URL}/changelog/`;

/** Microsite root, which introduces the Teamwork Graph itself. */
export const TWG_MICROSITE_HOME_URL = '/';
